export type Review = {
  quote: string
  name: string
  role: string
  city: string
  country: string
}

/**
 * Reseñas de compradores reales de Ice Machine Diagnostic Pro.
 * Vacío a propósito: la sección no se muestra hasta que haya reseñas reales.
 */
export const reviews: Review[] = []
